import { hubDevStackHealthzUrl } from "./hubApiOrigin";

/** Baked into the UI bundle at build time; matches API `GET /healthz` `version` in production. */
export const HUB_BUILD_VERSION_META_NAME = "hub-build-version";

function readHubBuildVersionFromMeta(): string | null {
  if (typeof document === "undefined") {
    return null;
  }
  const meta = document.querySelector(`meta[name="${HUB_BUILD_VERSION_META_NAME}"]`);
  const content = meta?.getAttribute("content")?.trim();
  return content && content.length > 0 ? content : null;
}

/** Resolve client build version: serve-time meta, Vite env, then dev. */
export function resolveHubClientBuildVersion(
  metaContent: string | null | undefined,
  viteBuildVersion: string | null | undefined,
): string {
  const meta = metaContent?.trim();
  if (meta) {
    return meta;
  }
  const vite = viteBuildVersion?.trim();
  if (vite) {
    return vite;
  }
  return "dev";
}

export const HUB_CLIENT_BUILD_VERSION = resolveHubClientBuildVersion(
  readHubBuildVersionFromMeta(),
  import.meta.env?.VITE_BUILD_VERSION as string | undefined,
);

export const HUB_STALE_VERSION_MESSAGE =
  "A newer version of the hub is available. Refresh to load the latest page.";

const VERSION_POLL_INTERVAL_MS = 5 * 60 * 1000;

export { VERSION_POLL_INTERVAL_MS };

export function hubBuildVersionsDiffer(clientVersion: string, serverVersion: string): boolean {
  const client = clientVersion.trim();
  const server = serverVersion.trim();
  if (client === "dev" && server === "dev") {
    return false;
  }
  if (client.length === 0 || server.length === 0) {
    return false;
  }
  return client !== server;
}

export async function fetchHubServerBuildVersion(): Promise<string | null> {
  try {
    const response = await fetch(hubDevStackHealthzUrl(), { cache: "no-store" });
    if (!response.ok) {
      return null;
    }
    const body = (await response.json()) as { version?: unknown };
    return typeof body.version === "string" ? body.version.trim() : null;
  } catch {
    return null;
  }
}
